import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import useVehiclesList from "../components/fetchVehicles";
import VehicleInformation from "../components/vehicleInformation";
import Card from "../components/Card";
import Carousel from "react-bootstrap/Carousel";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import useWindowSize from "../components/useWindowSize";
import generateCarUrl from "../modules/generateCarUrl";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRoad } from '@fortawesome/free-solid-svg-icons'
import { faGasPump } from '@fortawesome/free-solid-svg-icons'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons'
import { faMoneyBillWave } from '@fortawesome/free-solid-svg-icons'
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons'

function CarsDetailsPage() {
    const { query  } = useParams();
    let isLoading = false;
    let isError = false;
    let otherOptions;
    const {width} = useWindowSize();

    const querySplitted = query.split("-")
    const id = querySplitted[querySplitted.length - 1]

    let vehicle =
        window.highlightedCars &&
        window.highlightedCars.find(item => item.id === parseInt(id));

    otherOptions =
        vehicle &&
        window.highlightedCars
            .filter(item => item.id !== vehicle.id)
            .slice(0, 3);

    const [
        listVehicles,
        isLoadingFromRequest,
        isErrorFromRequest
    ] = useVehiclesList();
    
    if (!vehicle) {
        vehicle = listVehicles.find(item => item.id === parseInt(id));
        isLoading = isLoadingFromRequest || !vehicle;
        isError = isErrorFromRequest;
        otherOptions = listVehicles
            .filter(item => {
                if(!vehicle){
                    return false;
                }

                return item.id !== vehicle.id
            })
            .slice(0, 3);
    }

    return (
        <Fragment>
            <Breadcrumb className="breadcrumb_overrides">
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/lista-carros-usados-stand-pombal">
                    Lista de carros usados pombal 
                </Breadcrumb.Item>
                <Breadcrumb.Item active>{name}</Breadcrumb.Item>
            </Breadcrumb>
            {isError && <div>Ocorreu um erro ...</div>}
            {isLoading ? (
                <div 
                    className="d-flex justify-content-center loadingContainer" 
                    style={{ height: width > 768 ? "2800px":"1800px" }}
                >
                    <div className="sk-chase">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            ) : (
                renderCar()
            )}
        </Fragment>
    );

    function renderCar() {

        const {
            list_images,
            name,
            description,
            power,
            price,
            registration_month,
            registration_year,
            mileage,
            fuel,
            make,
            model,
            gear_type,
            color,
            cc,
            number_doors,
            number_seats,
            list_extras
        } = vehicle;

        return (
            <Fragment>
                <VehicleInformation {...vehicle} />
                <section className="mb-3 container cardDetails_container">
                    <div className="row justify-content-center mb-3">
                        <h3 className="text-left w-100 car_description">
                            {name}
                        </h3>
                    </div>
                    <Carousel className="container-header-car-detail">
                        {list_images.map((image, index) => {
                            return (
                                <Carousel.Item key={index}>
                                    <img
                                        className="d-block w-100 cardDetails_image"
                                        src={image}
                                        alt={`Car Image ${name}`}
                                        loading="eager"
                                        width={width > 768 ? "900":"280"}
                                        height={width > 768 ? "500":"210"}
                                    />
                                </Carousel.Item>
                            );
                        })}
                    </Carousel>
                    <div className="separator d-block" />
                    <div className="col-xs-12 mt-2 d-block d-md-none">
                        <div className="col-xs-12">
                            <p className="vehicleDetailTitle">
                                <b>
                                    {make} - {model}
                                </b>
                                <br />
                                {name}
                            </p>
                            <div className="col-xs-12 d-flex justify-content-between px-3">
                                <span>
                                    <FontAwesomeIcon icon={faCalendar}  className="mr-1"/>
                                    {registration_year}
                                </span>
                                <span>
                                    <FontAwesomeIcon icon={faRoad}  className="mr-1"/>
                                    {mileage} Km
                                </span>
                                <span>
                                    <FontAwesomeIcon icon={faGasPump}  className="mr-1"/>
                                    {fuel}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 d-flex d-md-none justify-content-center">
                        <a
                            href="tel:917614429"
                            className="text-white col-11 p-0"
                        >
                            <div
                                className="vehicleDetailMobilePhone"
                                style={{ cursor: "pointer" }}
                            >
                                Ligar
                                <FontAwesomeIcon icon={faPhoneAlt}  className="ml-3"/>
                            </div>
                        </a>
                        <div className="col-11 vehicleDetailMobilePrice mt-3">
                            <span className="cardDetails_price">
                                <span className="pr-3">
                                    {" "}
                                    {price.toLocaleString()} €
                                </span>
                                <span className="cardDetails_currency">
                                    EUR
                                </span>
                            </span>
                        </div>
                        <div className="col-11 vehicleDetailCredito mt-3">
                            <FontAwesomeIcon icon={faMoneyBillWave}  className="mr-1"/>
                            Crédito c/ ou s/ entrada de 12 a 120 meses
                        </div>
                        <div className="text-center mt-3">
                            <p>
                                <b>*Negociável, Aceitamos retoma</b>
                            </p>
                        </div>
                    </div>
                    <div className="row mt-3 justify-content-center">
                        <div className="col-11">
                            <h5 className="red-text">
                                <b>Dados Técnicos</b>
                            </h5>
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td className="text-secondary border-top-0">
                                            Cor
                                        </td>
                                        <td className=" border-top-0">
                                            {color}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Ano de matrícula
                                        </td>
                                        <td>{registration_year}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Mês de matrícula
                                        </td>
                                        <td>{registration_month}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Nº de Portas
                                        </td>
                                        <td>{number_doors}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Lotação
                                        </td>
                                        <td>{number_seats}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Cilindrada
                                        </td>
                                        <td>{cc} cc</td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Potência
                                        </td>
                                        <td>{power} cv</td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Transmissão
                                        </td>
                                        <td>{gear_type}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-secondary">
                                            Garantia
                                        </td>
                                        <td>2 Anos (por mutuo acordo)</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row justify-content-center lista-extras">
                        <div className="col-11">
                            <h6 className="mb-1">
                                <b>Extras</b>
                            </h6>
                            <div className="col-xs-12 no-padding mt-2 row">
                                {list_extras.map(extra => {
                                    return (
                                        <div className="col-xs-12 col-sm-6 extra-solto get-ellipsis">
                                            {extra}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 justify-content-center">
                        <div className="col-11">
                            <h5 className="red-text">
                                <b>Descrição</b>
                            </h5>
                            {description}
                        </div>
                    </div>
                    <div className="row mt-3 justify-content-center">
                        <h5 className="col-11 red-text mb-2">
                            <b>Outras Opções</b>
                        </h5>
                        {otherOptions.map(vehicle => {
                            const {
                                list_images,
                                name,
                                id,
                                make,
                                model,
                                gear_type,
                                registration_year,
                                registration_month,
                                price,
                                mileage,
                                fuel,
                                power
                            } = vehicle;
                            return (
                                <div
                                    className="col-sm-6 my-2 col-lg-3"
                                    key={id}
                                >
                                    <Card
                                        img={list_images[0]}
                                        name={name}
                                        make={make}
                                        model={model}
                                        gear_type={gear_type}
                                        registration_year={registration_year}
                                        registration_month={registration_month}
                                        mileage={mileage}
                                        price={price}
                                        fuel={fuel}
                                        id={id}
                                        power={power}
                                        carUrl={
                                            generateCarUrl({
                                                id,
                                                make,
                                                model,
                                                price,
                                                registration_year,
                                                registration_month,
                                            })
                                        }
                                    />
                                </div>
                            );
                        })}
                    </div>
                    <div className="row mt-3 justify-content-center">
                        <div className="col-11">
                            <h5 className="red-text mb-2 text-center">
                                <Link
                                    style={{ cursor: "pointer" }}
                                    to={"/lista-carros-usados-stand-pombal/"}
                                >
                                    <FontAwesomeIcon icon={faLongArrowAltLeft}  className="mr-2"/>
                                    <b>Voltar a ver lista</b>
                                </Link>
                            </h5>
                        </div>
                    </div>
                </section>
            </Fragment>
        );
    }
}

export default CarsDetailsPage;
